export const getTrialCartPricesEndpoint = (builder) => ({
    getTrialCartPrices: builder.query({
        query: (cartId) => ({
            isTrial: true,
            method: "getCustomerCartPrices",
            params: [cartId],
        }),
        providesTags: ["Cart"],
    }),
});
//# sourceMappingURL=getTrialCartPrices.endpoint.js.map